(function () {
  var bar = document.getElementById('page-loading-bar');
  if (!bar) return;
  var timer;

  function start() {
    clearInterval(timer);
    bar.style.transition = 'none';
    bar.style.width = '0%';
    bar.classList.add('is-loading');
    void bar.offsetWidth;
    bar.style.transition = '';
    var progress = 0;
    timer = setInterval(function () {
      progress += (100 - progress) * 0.1;
      bar.style.width = Math.min(progress, 90) + '%';
    }, 200);
  }

  function finish() {
    clearInterval(timer);
    bar.style.width = '100%';
    setTimeout(function () {
      bar.classList.remove('is-loading');
      setTimeout(function () {
        bar.style.width = '0%';
      }, 300);
    }, 200);
  }

  window.addEventListener('pageshow', finish);
  window.addEventListener('load', finish);

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    if (link.target === '_blank' || link.hasAttribute('download')) return;
    if (link.href.indexOf(window.location.origin) !== 0) return;
    if (link.href.split('#')[0] === window.location.href.split('#')[0]) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    start();
  });

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.tagName === 'FORM') start();
  });
})();
